import { MAX_STORY_LENGTH } from "../utils/MemoryExperience";
import styles from "../assets/styles/RandomDiversity2026Ticket.module.css";

export default function MemoryStoryFields({ story, onStoryChange, consent, onConsentChange, disabled = false }) {
  return <fieldset className={styles.storyFields} disabled={disabled}>
    <legend>사진에 남아 있는 이야기</legend>
    <p id="memory-story-hint">언제, 누구와 있던 순간인가요? 지금 이 사진을 보면 떠오르는 마음을 들려주세요. 쓰고 싶지 않은 내용은 적지 않아도 괜찮아요.</p>
    <label htmlFor="memory-story">나의 이야기</label>
    <textarea id="memory-story" value={story} onChange={event => onStoryChange(event.target.value)}
      maxLength={MAX_STORY_LENGTH} rows={6} required aria-describedby="memory-story-hint memory-story-count"
      placeholder="그날 우리는 별것 아닌 일에도 오래 웃었습니다. 이 사진을 다시 보면…" />
    <span id="memory-story-count" className={styles.storyCount}>{story.length.toLocaleString()} / 4,000자</span>
    <label className={styles.consentLabel}>
      <input type="checkbox" checked={consent} onChange={event => onConsentChange(event.target.checked)} required aria-describedby="memory-storage-notice" />
      <span>사진과 이야기를 OpenAI에 전송해 시와 감정 단어를 생성하고, 체험용 사진 사본·이야기·생성된 시와 감정 단어를 티켓에 연결해 30일 동안 보관하는 데 동의합니다.</span>
    </label>
    <p id="memory-storage-notice" className={styles.storyPrivacy}>30일이 지나면 삭제를 순차적으로 처리하므로 기간 만료 즉시 삭제되는 것은 아닙니다. 원본 사진의 보관·삭제에는 기존 사진 업로드 정책이 별도로 적용됩니다. 삭제 등 자세한 문의는 현장 스태프에게 해 주세요.</p>
    <p className={styles.storyPrivacy}>이야기는 색 추출값을 바꾸지 않습니다. 감정 단어는 AI의 문학적 해석이며 뇌파로 판독한 감정이 아닙니다. 다른 사람의 민감한 개인정보는 적지 말아 주세요.</p>
  </fieldset>;
}
